import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import bgImg from '../Images/blogs.webp'
import Breadcrumb from "../Components/Breadcrumb";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { blogs } from '../Blog';
import { FaSearch } from "react-icons/fa";
import BlogSchema from "../Schema/BlogSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const Blog=()=>{
     useEffect(() => {
            document.title =
              "Ayurvedic Treatment Blog Bhuj | Dr. Jigar Gor ";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Stay updated with the official Ayurvedic blog by Dr. Jigar Gor in Kutch. Discover trusted guides on Panchkarma, home remedies, skin care, and diet plans."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://msayurved.com/blog");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Ayurvedic Treatment Blog Bhuj | Dr. Jigar Gor "
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Stay updated with the official Ayurvedic blog by Dr. Jigar Gor in Kutch. Discover trusted guides on Panchkarma, home remedies, skin care, and diet plans."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://msayurved.com/blog");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://msayurved.com/Images/blogs.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Ayurvedic Treatment Blog Bhuj | Dr. Jigar Gor "
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Stay updated with the official Ayurvedic blog by Dr. Jigar Gor in Kutch. Discover trusted guides on Panchkarma, home remedies, skin care, and diet plans."
            );
          }
        
           const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://msayurved.com/Images/blogs.webp"
            );
          }
          }, []);


const sidebarVariant = {
  hidden: {
    opacity: 0,
    x: 40,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState("");
const [selectedCategory, setSelectedCategory] = useState("All");
const [appliedSearch, setAppliedSearch] = useState("");

const navigate = useNavigate();

const BLOGS_PER_PAGE = 6;

const handlePageChange = (newPage) => {
  setCurrentPage(newPage);

  navigate(`/blog?page=${newPage}`, {
    replace: true,
  });

  setTimeout(() => {
    const element = document.getElementById("blog-grid");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 50);
};

const getPageFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get("page"), 10);

  return page && page > 0 ? page : 1;
};

const [currentPage, setCurrentPage] = useState(getPageFromUrl);

  const categoriesList = ["All"];

blogs.forEach((blog) => {
  if (
    blog.category &&
    !categoriesList.includes(blog.category)
  ) {
    categoriesList.push(blog.category);
  }
});

const handleCategoryClick = (categoryName) => {
  setSelectedCategory(categoryName);
  setSearchTerm("");
  setAppliedSearch("");

  // Reset pagination to page 1
  setCurrentPage(1);

  navigate("/blog", {
    replace: true,
  });
};

const suggestions = [];

const cleanTerm = searchTerm
  .trim()
  .toLowerCase();

if (cleanTerm !== "") {

  categoriesList.forEach((cat) => {

    if (
      cat !== "All" &&
      cat.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "category",
        value: cat,
      });
    }

  });

  blogs.forEach((blog) => {

    if (
      blog.title
        .toLowerCase()
        .includes(cleanTerm)
    ) {
      suggestions.push({
        type: "blog",
        value: blog.title,
        slug: blog.slug,
      });
    }

  });

}

const handleKeyDown = (e) => {

  if (e.key === "Enter") {

    if (suggestions.length > 0) {

      const topResult =
        suggestions[0];

      if (
        topResult.type === "category"
      ) {

        setSelectedCategory(
          topResult.value
        );

        setSearchTerm("");
        setAppliedSearch("");

      } else {

        window.location.href =
          `/blog/${topResult.slug}`;

      }

    } else {

  setAppliedSearch(searchTerm);

  setCurrentPage(1);

  navigate("/blog", {
    replace: true,
  });
}

  }

};
const filteredBlogs = blogs.filter(
  (blog) => {

    const matchesCategory =
      selectedCategory === "All" ||
      blog.category ===
        selectedCategory;

    const cleanAppliedSearch =
      appliedSearch
        .trim()
        .toLowerCase();

    const matchesSearch =
      cleanAppliedSearch === "" ||
      blog.title
        .toLowerCase()
        .includes(
          cleanAppliedSearch
        ) ||
      blog.category
        .toLowerCase()
        .includes(
          cleanAppliedSearch
        );

    return (
      matchesCategory &&
      matchesSearch
    );

  }
);

const totalPages = Math.ceil(
  filteredBlogs.length / BLOGS_PER_PAGE
);

// Make sure current page is never greater than total pages
const safeCurrentPage =
  totalPages > 0
    ? Math.min(currentPage, totalPages)
    : 1;

const startIndex =
  (safeCurrentPage - 1) * BLOGS_PER_PAGE;

const paginatedBlogs = filteredBlogs.slice(
  startIndex,
  startIndex + BLOGS_PER_PAGE
);

useEffect(() => {
    if (location.state) {
     if (location.state.selectCategory) {

  setSelectedCategory(location.state.selectCategory);
  setSearchTerm("");
  setAppliedSearch("");
  setCurrentPage(1);

} else if (location.state.searchString) {

  setAppliedSearch(location.state.searchString);
  setSearchTerm(location.state.searchString);
  setSelectedCategory("All");
  setCurrentPage(1);

}
      
      // Smoothly push view into focus right after updating state
      setTimeout(() => {
        const element = document.getElementById("blog-grid");
        if (element) {
          element.scrollIntoView();
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
  const page = getPageFromUrl();

  setCurrentPage(page);
}, [location.search]);


const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Blogs",
      url: "https://msayurved.com/blog/"
    },
  ];
    return(
        <>

      <BlogSchema />
      <BreadcrumbSchema items={breadcrumbItems} />

        {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Holistic Health & Wellness Insights"
        bgImage={bgImg}
        />

        {/**BLOG CARDS + CATEGORY SECTION */}
       <motion.section
  className="blog-listing-section container"
  id="blog-grid"
>

  {/* LEFT */}

  <div className="blog-listing-left">

    <motion.div
      className="blog-intro"
    >

      <p className="section-subheading">
        Insights & Articles
      </p>

      <h2 className="section-heading">
        Timeless secrets for everyday wellness.
      </h2>

    </motion.div>

    <motion.div
      className="blog-grid"
    >

      {filteredBlogs.length === 0 ? (

  <div className="no-blogs-section">

    <h3 className="card-heading">
      No Blogs Found
    </h3>

    <p className="section-text">
      No articles match your search.
    </p>

    <button
      className="nav-btn"
      onClick={() =>
        handleCategoryClick("All")
      }
    >
      Reset Filters
    </button>

  </div>

) : (

  paginatedBlogs.map((item, i) => (
      <motion.div
          className="blog-card"
          key={i}
        >
          <div
            style={{
              overflow: "hidden",
            }}
          >
            <motion.img
              src={item.img}
              alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
            />
          </div>

          <div className="blog-card-content">

            <h3 className="card-heading">
              {item.title}
            </h3>

            <p className="section-text">
              {item.intro}
            </p>

            <motion.a
              href={`/blog/${item.slug}`}
            >
              Read Full Article →
            </motion.a>

          </div>
        </motion.div>
  ))

)}

    </motion.div>
{totalPages > 1 && (
  <div className="blog-pagination">

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === 1}
      onClick={() =>
        handlePageChange(safeCurrentPage - 1)
      }
    >
      Previous
    </button>

    <span className="pagination-info">
      Page {safeCurrentPage} of {totalPages}
    </span>

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === totalPages}
      onClick={() =>
        handlePageChange(safeCurrentPage + 1)
      }
    >
      Next
    </button>

  </div>
)}

  </div>

  {/* RIGHT */}

  <motion.aside
    className="blog-sidebar"
    variants={sidebarVariant}
  >

    <motion.div
      className="blog-sidebar-card"
    >

      <div className="blog-search">

      <input
  type="text"
  placeholder="Search Category / Articles"
  value={searchTerm}
  onChange={(e) =>
    setSearchTerm(e.target.value)
  }
  onKeyDown={handleKeyDown}
/>

{suggestions.length > 0 && (

  <div className="blog-search-dropdown">

    {suggestions.map(
      (item, idx) => (

        <div
          key={idx}
          className="blog-search-item"
          onClick={() => {

            if (
              item.type ===
              "category"
            ) {

              handleCategoryClick(
                item.value
              );

            } else {

              window.location.href =
                `/blog/${item.slug}`;

            }

          }}
        >

          <span>
            {item.type ===
            "category"
              ? "Category"
              : "Blog"}
          </span>

          {item.value}

        </div>

      )
    )}

  </div>

)}

        <FaSearch />

      </div>

      <h3 className="card-heading">
        Categories
      </h3>

     <div className="blog-page-category-list">

  {categoriesList.map(
    (item, index) => (

      <button
        key={index}
        className={`blog-category-btn ${
          selectedCategory === item
            ? "active"
            : ""
        }`}
        onClick={() =>
          handleCategoryClick(item)
        }
      >
        {item}
      </button>

    )
  )}

</div>
    </motion.div>

    <motion.div
      className="blog-cta-card"
    >

      <p className="section-subheading">
        Your Wellness, Our Commitment.
      </p>

      <h3 className="card-heading">
        Begin Your Healing Journey Today
      </h3>

      <p className="section-text">
        Experience the power of authentic Ayurveda through
        personalized consultations, holistic therapies,
        and time-tested healing practices designed to
        restore balance, improve overall well-being, and
        naturally transform your health from within. Our
        expert-guided treatments focus on identifying the
        root cause and helping you achieve long-lasting
        physical, mental, and emotional wellness.
      </p>

      <motion.div
      >
        <NavLink
          to="/book-appointment"
          className="nav-btn"
        >
          Book Appointment
        </NavLink>
      </motion.div>

    </motion.div>

  </motion.aside>

</motion.section>

        </>
    )
}
export default Blog;